import axios from 'axios';
import JustValidate from 'just-validate';

import utils from './functions-base/utils';

declare let core_object: any;
declare let auth_object: any;

// Utils
const modUtils = new utils();

export default class authSignin{

    protected elForm: string;
    protected elFormAlert: string;
    protected elFormBtn: string;
    protected elFormSpin: string = 'bgdrop-spin';
    protected url_api_signin: string;

    /**
     * Constructor
     * @param elForm 
     * @param elFormAlert 
     * @param elFormBtn 
     */
    constructor(
        elForm: string,
        elFormAlert: string,
        elFormBtn: string
    ){

        this.elForm = elForm;
        this.elFormAlert = elFormAlert;
        this.elFormBtn = elFormBtn;
        this.url_api_signin = auth_object.rest_urls.auth_signin;

    }

    /**
     * Init form
     */
    initForm(){
        
        const _that = this;

        const form = document.querySelector(_that.elForm) as HTMLElement | null;

        if(form !== null){

            // Validate form
            _that.validateLogin();

        }
        
    }

    /**
     * Validation login
     * @returns 
     */
    protected validateLogin(){
        
        const _that = this;

        const validation = new JustValidate(this.elForm, {
            errorFieldCssClass: 'is-invalid border border-red-300',
            errorLabelCssClass: 'just-validate-error-label flex flex-row flex-wrap basis-full w-full mt-1 !text-red-300',
            focusInvalidField: true,
            lockForm: true,
        });

        validation.addField('#auth_signin_email', [
            {
                rule: 'required',
                errorMessage: auth_object.error_messages.email_required,
            },
            {
                rule: 'email',
                errorMessage: auth_object.error_messages.email_invalid,
            },
        ])
        .addField('#auth_signin_password', [
            {
                rule: 'required',
                errorMessage: auth_object.error_messages.password_required,
            },
        ])
        .onSuccess((event: any) => {
                
                event.preventDefault();
            
                _that.sendApi(event?.currentTarget);
                
        });

        return validation;

    }

    /**
     * 
     * @param form Send Credentials
     */
    protected sendApi(form: HTMLFormElement) {
        
        const _that = this;

        // Get form data
        const data = new FormData(form); 
        
        // Conver form data to string
        const datastring = new URLSearchParams(data as any).toString();

        // Button login
        const btn = document.getElementById(this.elFormBtn) as HTMLInputElement | null;

        // Init post data
        const post_data = {
            ajax_nonce: core_object.ajaxNonce,
            'fields': datastring
        };

        // Create query string
        const queryString = new URLSearchParams(post_data).toString();

        // Set disabled attribute
        btn?.setAttribute('disabled', '');

        // Init spin
        const spin = modUtils.btnSpin(this.elFormSpin);

        // Append spin to button
        btn?.append(spin);

        // Call ajax
        axios.post(_that.url_api_signin, queryString)
            .then(function (response: any) {

            // Remove alert box
            modUtils.removeAlertBox(
                _that.elForm,
                _that.elFormAlert
            );

            // Remove spin
            spin.remove();
                
            // Remove disabled attribute
            btn?.removeAttribute('disabled');

            const responseStatus: boolean = response.data.status;
                
            // True
            if(responseStatus == true){
                
                // Refresh the page
                location.replace(response.data.redirect);

            }

            // False
            if(responseStatus == false){
                
                // Get errors
                const errors = response.data.errors;
                
                if(Array.isArray(errors)){
                    
                    errors.forEach(function(error){
                        
                        let alert = modUtils.alertBox(
                            _that.elFormAlert,
                            auth_object.general_message.error,
                            error
                        );
                        form.prepend(alert);

                    });

                }else{
                    
                    const alert = modUtils.alertBox(
                        _that.elFormAlert,
                        auth_object.general_message.error,
                        errors
                    );
                    form.prepend(alert);

                }
  
            }

        })
        .catch(function (error:any){

            // Remove spin
            spin.remove();

            // Remove disabled attribute
            btn?.removeAttribute('disabled');

        });

    }
    
}